"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WIDGET_LOADED = exports.WIDGET_HIDDEN = exports.WIDGET_CLOSED = exports.USER_SELECTED_THREAD = exports.USER_INTERACTED_WITH_WIDGET = exports.UNREAD_CONVERSATION_COUNT_CHANGED = exports.SDK_CLOSE_BUTTON_CLICK = exports.QUICK_REPLY_BUTTON_CLICK = exports.INPUT_STAGING = exports.CONVERSATION_STARTED = exports.CONVERSATION_CLOSED = exports.CONTACT_ASSOCIATED = void 0;
const CONVERSATION_STARTED = exports.CONVERSATION_STARTED = 'conversationStarted';
const CONVERSATION_CLOSED = exports.CONVERSATION_CLOSED = 'conversationClosed';
const UNREAD_CONVERSATION_COUNT_CHANGED = exports.UNREAD_CONVERSATION_COUNT_CHANGED = 'unreadConversationCountChanged';
const INPUT_STAGING = exports.INPUT_STAGING = 'inputStaging';
const CONTACT_ASSOCIATED = exports.CONTACT_ASSOCIATED = 'contactAssociated';
const USER_INTERACTED_WITH_WIDGET = exports.USER_INTERACTED_WITH_WIDGET = 'userInteractedWithWidget';
const QUICK_REPLY_BUTTON_CLICK = exports.QUICK_REPLY_BUTTON_CLICK = 'quickReplyButtonClick';
const WIDGET_LOADED = exports.WIDGET_LOADED = 'widgetLoaded';
const WIDGET_CLOSED = exports.WIDGET_CLOSED = 'widgetClosed';
const USER_SELECTED_THREAD = exports.USER_SELECTED_THREAD = 'userSelectedThread';
const WIDGET_HIDDEN = exports.WIDGET_HIDDEN = 'widgetHidden';
const SDK_CLOSE_BUTTON_CLICK = exports.SDK_CLOSE_BUTTON_CLICK = 'sdkCloseButtonClick';